import { colors, FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  itemsContainer: FelaCSS;
  item: FelaCSS;
  iconBox: FelaCSS;
  itemText: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    margin: `${spacing[8]} ${spacing[0]} ${spacing[6]}`,
    maxWidthTabletSm: {
      order: 6,
      margin: `${spacing[5]} ${spacing[4]} ${spacing[5]}`,
      paddingVertical: spacing[2],
    },
  },
  itemsContainer: {
    maxWidth: 715,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: spacing[6],
    rowGap: spacing[5],

    maxWidthTabletSm: {
      gridTemplateColumns: '1fr',
      rowGap: spacing[4],
    },
  },
  item: {
    gap: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconBox: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.indigoCrush10,
    borderRadius: '100%',

    maxWidthTabletSm: {
      width: 30,
      height: 30,
    },
  },
  itemText: {
    color: colors.space,
    fontDefaultSemiBold: 16,

    maxWidthTabletSm: {
      fontDefaultSemiBold: 14,
    },
  },
});

export default styles;
